export const PROCESS_SPEED = {
  VERY_SLOW: 'VERY_SLOW',
  SLOW: 'SLOW',
  NORMAL: 'NORMAL',
  FAST: 'FAST',
};

export const PROCESS_DIRECTION = {
  LOAD: 'LOAD',
  UNLOAD: 'UNLOAD',
};

export const DOOR_STATE = {
  UNLOADING: 'UNLOADING',
  LOADING: 'LOADING',
  EMPTY: 'EMPTY',
  STOPPED: 'STOPPED',
  NOT_STARTED: 'NOT STARTED',
  FINISHED: 'COMPLETE',
};

export const EQUIPMENT_TYPE = {
  CONTAINER: 'CONTAINER',
  TRAILER: 'TRAILER',
};